<template>
  <div class="col-12 row q-col-gutter-x-sm items-center">
    <model-form-select
      :field="sitesField"
      class="col-8"
      :label="`${(conditional.conditionsRequirements[excludeSitesField] ? 'Exclude' : 'Include')} Sites`"
      :options="$_.filter(sites.data, { isLibrary: false })"
      option-label="name"
      option-value="id"
      map-options
      emit-value
      multiple
      use-chips
      clearable
      bottom-slots
      :rules="[
        val => !!val || 'Field is required',
        val => val.length > 0 || 'Must select at least one site'
      ]"
    />
    <model-form-toggle
      :field="`conditionsRequirements.${excludeSitesField}`"
      class="col-4 q-mb-md"
      label="Exclude"
      value-type="Boolean"
    />
  </div>
</template>

<script>
import { CONDITION_REQUIREMENTS } from 'src/models/membership-type/MembershipPoint'

export default {
  name: 'SitesConditionForm',
  configuration: ['sites'],
  props: {
    conditional: {
      type: Object,
      required: true
    },
    sitesField: {
      type: String,
      default: CONDITION_REQUIREMENTS.SITES
    },
    excludeSitesField: {
      type: String,
      default: CONDITION_REQUIREMENTS.EXCLUDE_SITES
    }
  },
  computed: {
    siteOptions () {
      return _.filter(this.sites.data, { isLibrary: false, active: true })
    }
  }
}

</script>
